import api from './api';

const botToolLimitsService = {
  get: (workspaceId, botId) =>
    api.get(`/workspaces/${workspaceId}/bots/${botId}/tool-limits`),
  update: (workspaceId, botId, override) =>
    api.put(`/workspaces/${workspaceId}/bots/${botId}/tool-limits`, override),
};

export default botToolLimitsService;
